import { DAOButton } from "components/button"
import { Chart } from "react-chartjs-2"
import { ui, utils } from "services"
import 'chart.js/auto';

export const SharedRevenueCard = ({ revenueIncentives }: { revenueIncentives: any }) => {
  let data = revenueIncentives.map((i: any) => Number(i.pool))
  let total = data.reduce((prev: number, cur: number) => prev + cur, 0)
  return (
    <>
      <div className="text-white font-cookie font-bold text-2xl pt-8">Shared <br /> Revenue Incentive</div>
      <div className="w-[240px] mt-8 mx-auto text-center self-center justify-center charttoken relative min-h-[240px]">
        <div className="innertext-doughnut font-bold text-3xl font-cookie">{utils.convertToInternationalCurrencySystem(Number(total ?? 0))} <div className="text-lg font-cookie">MSTR</div></div>
        <Chart
          type='doughnut'
          data={
            {
              labels: ['In-game', '6 months', '9 months', '12 months'],
              datasets: [{
                data: data,
                backgroundColor: [
                  '#52ACFF',
                  '#FBE947',
                  '#EF7BE3',
                  '#76FFFF'
                ],
                hoverOffset: 20,
                hoverBorderWidth: 3,
                hoverBorderColor: '#c0c0c0',
              }],
            }
          }
          options={{
            responsive: true,
            animation: {
              animateScale: true,
              animateRotate: true
            },
            // @ts-ignore
            title: {
              display: true,
              fontSize: 20,
              text: 'One line of text'
            },
            layout: {
              padding: {
                top: 20,
                bottom: 20,
              },
            },
            plugins: {
              legend: {
                display: false,
                position: 'top',
              },
            },
            cutout: 70,
          }}
        />
      </div>

      <div className="mt-6">
        {revenueIncentives.map((i: any) => {
          return (
            <div className='flex justify-between'>
              <div className="flex gap-2">
                <div className="w-3 h-3 self-center justify-center" style={{
                  background: i.color
                }}></div>
                <div className="text-white self-center">{i.title} ({i.rate}%)</div>
              </div>
              <div className="text-white text-left font-bold">
              {utils.convertToInternationalCurrencySystem(Number(i.pool ?? 0))}  {" "}
                <img src="/assets/images/items/mstr-icon.svg" alt="mstr" className="inline-block mr-2 hidden md:inline-block h-5 w-5" />
              </div>
            </div>
          )
        })}
      </div>

      {/* <div className="w-4/5 mx-auto mt-10">
        <DAOButton color="yellow" theme="light" icon="mstr-icon.webp" className="py-3"
          onClick={() => {
            ui.openBuyToken('mstr');
          }}
        >
          Buy MSTR
        </DAOButton>
        <DAOButton color="green" theme="light" icon="mag-icon.webp" className="mt-4 py-3"
          onClick={() => {
            ui.openBuyToken('mag');
          }}
        >
          Buy MAG
        </DAOButton>
      </div> */}
    </>
  )
}

